import * as React from "react"
import { Box, Grid, Skeleton } from "@mui/material"
import { TooltipSeeker, CardSeeker, IconSeeker } from "@ui-seeker/core"
import { formatNumber, formatPercentage } from "@ui-seeker/utils"

import { ellipsisStyle } from "@utils"
import { useSellerDeepDiveShareMblData } from "../@hooks"
import SellerDeepDiveShareMblChartActions from "./actions"
import SellerDeepDiveShareMblChartLegend from "./Legend"
import { columnStructure, mainChartContainer, bgChart, styleShareItem, styleShareLabel, styleShareValue } from "./styles"
import { sellerDeepDiveChartActualPrice } from "../@signals"


export default function SellerDeepDiveShareMblChart({ column=false, ...props }) {

	const { color, dataChart, series, isLoading, selectedGroupedBy, handleSelectedGroupedBy, handleClickShowEvolution } = useSellerDeepDiveShareMblData()
	const isTopCategories = selectedGroupedBy === "id_category"

	if (isLoading) return <Skeleton variant="rectangular" height={500} />
	if (!dataChart?.length) return <></>
	
    return <CardSeeker 
			title={props.title} 
			actions={<SellerDeepDiveShareMblChartActions 
						selectedGroupedBy={selectedGroupedBy} 
						handleSelectedGroupedBy={handleSelectedGroupedBy} 
						handleClickShowEvolution={handleClickShowEvolution}
					/>}
		>
		<Grid container item xs={12} sx={column ? mainChartContainer : {}}>
			{dataChart.map((element, idx) => {
				return <Grid key={idx} container spacing={2}  sx={isTopCategories ? columnStructure : mainChartContainer}>
					<Grid item 
						xs={!column ? 1 : 12} 
						sx={{ cursor: 'pointer', display: 'flex', flexDirection: isTopCategories ? 'row' : 'column', alignItems: isTopCategories ? 'baseline' : '' }} 
						onClick={() => handleClickShowEvolution(element.groupedID)}
					>
						<Box 
							title={element.label}
							sx={{
								display: "inline-block",
								whiteSpace: "nowrap",
								verticalAlign: "middle",
								mr: 1,
								"&:hover": { textDecoration: 'underline'},
								...(!isTopCategories && ellipsisStyle(100))
							}}
						>
							{element.label}
						</Box>
						<IconSeeker icon={'chart-line'} sx={{ mr: 1,  color: 'primary.main'}}/>
					</Grid>

					<Grid item xs={!isTopCategories ? 11 : 12}>
						<Box sx={bgChart(column, (sellerDeepDiveChartActualPrice.value ? element.actualData : element.listData)?.length)} key={idx}>
							{(sellerDeepDiveChartActualPrice.value ? element.actualData : element.listData).map(({name, percentage}, idx) => {
								const active = true
								const valueFormatted = formatPercentage(percentage)

								const titleTooltip = <Box key={idx} component="span" sx={{textAlign: 'center'}}>
									<Box component="p" sx={{m: 0}} key={idx}>
										<Box component="strong">{name}</Box> {valueFormatted}
									</Box>
								</Box>

								const linkContent = <TooltipSeeker title={titleTooltip}>
									<Box component="span" key={idx}>
										{!column && <Box sx={styleShareLabel(column, formatNumber(percentage, {decimals: 0}))}>{name}</Box>}
										{!column && <>
											<Box component="span" sx={{height: '100%', ...styleShareValue(column, percentage, active)}}>{valueFormatted}</Box>
										</>}
									</Box>
								</TooltipSeeker>

								return <Box 
									sx={styleShareItem(column, percentage, color[name], active)}
									key={idx}
								>
									{linkContent}
								</Box>
							})}
						</Box>
					</Grid>

				</Grid>
			})}
		</Grid>

		<Grid container item xs={12}>
			<SellerDeepDiveShareMblChartLegend series={series} color={color} />
		</Grid>
		
	</CardSeeker>
}